import en from '../locales/en.json';
import ru from '../locales/ru.json';

export const LOCALES = ['ru', 'en'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'ru';

/** Russian is the source of truth for keys; English must mirror it (see tests). */
export type MessageKey = keyof typeof ru;

const CATALOGS: Readonly<Record<Locale, Readonly<Record<string, string>>>> = { ru, en };

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

export function hasKey(key: string, locale: Locale = DEFAULT_LOCALE): boolean {
  return Object.hasOwn(CATALOGS[locale], key);
}

export function keys(locale: Locale = DEFAULT_LOCALE): string[] {
  return Object.keys(CATALOGS[locale]);
}

/**
 * Translate `key`, substituting `{name}` placeholders from `params`.
 * Falls back to Russian, then to the key itself, so a missing string is
 * visible in the UI instead of crashing it.
 */
export function t(
  locale: Locale,
  key: MessageKey | (string & {}),
  params: Readonly<Record<string, string | number>> = {},
): string {
  const template = CATALOGS[locale][key] ?? CATALOGS[DEFAULT_LOCALE][key] ?? key;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  );
}
